import React, { useEffect, useRef } from 'react';

const VideoPlayer = ({ service, onClose }) => {
  const videoRef = useRef(null);
  
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  
  useEffect(() => {
    // Ensure video plays when component mounts
    if (videoRef.current) {
      const playVideo = () => {
        videoRef.current.play().catch(error => {
          console.log('Video autoplay failed:', error);
          // Try again on user interaction
          const handleUserInteraction = () => {
            videoRef.current.play().catch(console.error);
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('touchstart', handleUserInteraction);
          };
          document.addEventListener('click', handleUserInteraction, { once: true });
          document.addEventListener('touchstart', handleUserInteraction, { once: true });
        });
      };
      
      // Small delay to ensure video is loaded
      setTimeout(playVideo, 100);
    }
  }, [service]);

  return (
    <div className="tv-screen-content">
      {/* Video section - left side of TV screen */}
      <div className="tv-video-section">
        {service.id === 'promo' ? (
          <iframe 
            className="tv-video"
            src="https://www.youtube.com/embed/Sq5dNwrCxSE?si=CWzq_cIt6jkBtbzh&autoplay=1&mute=1&loop=1&playlist=Sq5dNwrCxSE"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) : service.id === 'corporate' ? (
          <iframe 
            className="tv-video"
            src="https://www.youtube.com/embed/9c9gw_RQ4bk?si=vipYm4vO3tyV4VCE&autoplay=1&mute=1&loop=1&playlist=9c9gw_RQ4bk"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) : service.id === 'music' ? (
          <iframe 
            className="tv-video"
            src="https://www.youtube.com/embed/iWuAn5TH8a8?si=hUAMnkiEZOg-vVY9&autoplay=1&mute=1&loop=1&playlist=iWuAn5TH8a8"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) : service.id === 'film' ? (
          <iframe 
            className="tv-video"
            src="https://www.youtube.com/embed/mcZ58i0RGoc?si=cALaeU2shLZOyein&autoplay=1&mute=1&loop=1&playlist=mcZ58i0RGoc"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        ) : (
          <video 
             ref={videoRef}
             className="tv-video"
             autoPlay
             muted
             loop
             playsInline
             preload="auto"
             onLoadedData={() => {
               if (videoRef.current) {
                 videoRef.current.play().catch(error => {
                   console.log('Video play on load failed:', error);
                 });
               }
             }}
             onError={(e) => console.log('Video failed to load:', e)}
           >
            <source 
              src={`./${service.id === 'music' ? 'MusicVideos' : 
                       service.id === 'corporate' ? 'Corparate' : 
                       service.id === 'film' ? 'Film' : ''}.mp4`} 
              type="video/mp4" 
            />
            Your browser does not support the video tag.
          </video>
        )}
      </div>
      
      {/* Info section - right side of TV screen */}
      <div className="tv-info-section">
        <div className="tv-info-content">
          <button className="tv-close-button" onClick={onClose}>&times;</button>
          <h2>{service.title}</h2>
          <div className="tv-service-description" dangerouslySetInnerHTML={{ __html: service.description }} />
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;